import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import { connect } from "react-redux";
import { Helmet } from 'react-helmet';
import { bindActionCreators } from "redux";
import { getAboutCorporateContent, postCsr } from "../actions";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { getRouting, formDataGenerator, checkIframeContent} from "../../../../../utils/common";
import "./style.scss";
import "../style.scss";
import CsrModal from "./CsrModal";
import PageNotFound from "../../PageNotFound";

const CorporateProfile = (props) => {
  const {
    getAboutCorporateContent,
    aboutUsMsgData,
    postCsr,
    postCsrData,
    location: { pathname },
  } = props;

  const getCurrent = (nc) => {
    switch (nc) {
      case "hdfc-mf-at-a-glance":
        return 0;
      case "what-we-stand-for":
        return 1;
      case "esg":
        return 2;
      case "csr":
        return 3;
      case "what-sets-us-apart":
        return 4;
      default:
        return 0;
    }
  };

  // const current = window.location.pathname.split('/')[3];
  const current = pathname.split("/")[3];
  const [selectedIndexTab, setSelectedIndexTab] = useState(getCurrent(current));
  const [currentPageurl, setCurrentPageurl] = useState("hdfc-mf-at-a-glance");
  const [open, setOpen] = useState(false);
  const [hdfcMfGlanceData, setHdfcMfGlanceData] = useState();
  const [whatWeCareData, setWhatWeCareData] = useState();
  const [whatWestandForData, setwhatWestandForData] = useState();
  const [whatSetsUsApart, setWhatSetsUsApart] = useState();
  const [esgData, setEsgData] = useState();
  const [overView, setOverView] = useState();
  const [csrList, setCsrList] = useState();
  const [defaultYear, setDefaultYear] = useState("");
  const [modalData, setModalData] = useState("");
  // const [show, setShow] = useState(false);
  const [isOpenModel, setIsOpenModel] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [metaData, setMetaData] = useState("");
  const [flag , setFlag] = useState(false);

  useEffect(() => {
    if (current) {
      setCurrentPageurl(current);
    }
  }, [current]);

  useEffect(() => {
    if (defaultYear == "") {
      if (
        postCsrData &&
        postCsrData.csr &&
        postCsrData.csr.data &&
        postCsrData.csr.data.years &&
        postCsrData.csr.data.years[0] &&
        postCsrData.csr.data.years[0].value
      ) {
        setDefaultYear(postCsrData.csr.data.years[0].value);
      }
    }
  }, [postCsrData]);

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);

  useEffect(() => {
    // getAboutCorporateContent && getAboutCorporateContent({}, currentPageurl);

    let params = {
      year: defaultYear ? defaultYear : "",
    };
    // postCsr && postCsr(formDataGenerator(params));

    if (window.location.pathname.split('/')[3] === "hdfc-mf-at-a-glance") {
      setSelectedIndexTab(0);
      !(aboutUsMsgData && aboutUsMsgData.aboutUs && aboutUsMsgData.aboutUs.data && aboutUsMsgData.aboutUs.data[0] && aboutUsMsgData.aboutUs.data[0].title == "HDFC MF at a Glance" && flag == false) && getAboutCorporateContent({}, currentPageurl);
    }
    if (window.location.pathname.split('/')[3] === "what-we-stand-for") {
      setSelectedIndexTab(1);
      !(aboutUsMsgData && aboutUsMsgData.aboutUs && aboutUsMsgData.aboutUs.data && aboutUsMsgData.aboutUs.data[0] && aboutUsMsgData.aboutUs.data[0].title == "What we stand for" && flag == false) && getAboutCorporateContent({}, currentPageurl);
    }
    if (window.location.pathname.split('/')[3] === "esg") {
      setSelectedIndexTab(2);
      !(aboutUsMsgData && aboutUsMsgData.aboutUs && aboutUsMsgData.aboutUs.data && aboutUsMsgData.aboutUs.data.title == "Environmental, Social and Governance (ESG)" && flag == false) && getAboutCorporateContent({}, currentPageurl);
    }
    if (window.location.pathname.split('/')[3] === "csr") {
      setSelectedIndexTab(3);
      !(postCsrData && postCsrData.csr && postCsrData.csr.data && postCsrData.csr.data.title == "Corporate Social Responsibility (CSR)" && flag == false) && postCsr(formDataGenerator(params));
    }
    if (window.location.pathname.split('/')[3] === "what-sets-us-apart") {
      setSelectedIndexTab(4);
      !(aboutUsMsgData && aboutUsMsgData.aboutUs && aboutUsMsgData.aboutUs.data && aboutUsMsgData.aboutUs.data[0] && aboutUsMsgData.aboutUs.data[0].title == "What Sets Us Apart" && flag == false) && getAboutCorporateContent({}, currentPageurl);
    }
  }, [currentPageurl]);

  // useEffect(() => {
  //   const isHdfcMfGlance = window.location.href.indexOf("hdfc-mf-at-a-glance");
  //   const isWhatStandFor = window.location.href.indexOf("what-we-stand-for");
  //   // const isWhatWeCare = window.location.href.indexOf("what-we-care-about");
  //   const esg = window.location.href.indexOf("esg");
  //   const csr = window.location.href.indexOf("csr");
  //   const isWhatSetApart = window.location.href.indexOf("what-sets-us-apart");

  //   if (isHdfcMfGlance > 0) {
  //     setCurrentPageurl("hdfc-mf-at-a-glance");
  //   }
  //   if (isWhatStandFor > 0) {
  //     setCurrentPageurl("what-we-stand-for");
  //   }
  //   // if (isWhatWeCare > 0) {
  //   //   setCurrentPageurl("what-we-care-about")
  //   // }
  //   if (esg > 0) {
  //     setCurrentPageurl("esg");
  //   }
  //   if (csr > 0) {
  //     setCurrentPageurl("csr");
  //   }
  //   if (isWhatSetApart > 0) {
  //     setCurrentPageurl("what-sets-us-apart");
  //   }
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (aboutUsMsgData && aboutUsMsgData.aboutUs) {
      if (window.location.pathname.split('/')[3] === "hdfc-mf-at-a-glance") {
        setHdfcMfGlanceData(aboutUsMsgData.aboutUs.data[0]);
        setOverView(
          aboutUsMsgData &&
          aboutUsMsgData.aboutUs.overview &&
          aboutUsMsgData.aboutUs.overview
        );
        setMetaData(aboutUsMsgData &&
          aboutUsMsgData.aboutUs.meta &&
          aboutUsMsgData.aboutUs.meta);
      }

      // if (currentPageurl === 'what-we-care-about')
      //   setWhatWeCareData(aboutUsMsgData.aboutUs.data[0]);
      // setOverView(aboutUsMsgData && aboutUsMsgData.aboutUs.overview && aboutUsMsgData.aboutUs.overview)
      if (window.location.pathname.split('/')[3] === "what-we-stand-for") {
        setwhatWestandForData(aboutUsMsgData.aboutUs.data[0]);
        setOverView(
          aboutUsMsgData &&
          aboutUsMsgData.aboutUs.overview &&
          aboutUsMsgData.aboutUs.overview
        );
        setMetaData(aboutUsMsgData &&
          aboutUsMsgData.aboutUs.meta &&
          aboutUsMsgData.aboutUs.meta);
      }

      if (window.location.pathname.split('/')[3] === "what-sets-us-apart") {
        setWhatSetsUsApart(aboutUsMsgData.aboutUs.data[0]);
        setOverView(
          aboutUsMsgData &&
          aboutUsMsgData.aboutUs.overview &&
          aboutUsMsgData.aboutUs.overview
        );
        setMetaData(aboutUsMsgData &&
          aboutUsMsgData.aboutUs.meta &&
          aboutUsMsgData.aboutUs.meta);
      }

      if (window.location.pathname.split('/')[3] === "esg") {
        setEsgData(aboutUsMsgData.aboutUs.data)
        setOverView(
          aboutUsMsgData &&
          aboutUsMsgData.aboutUs.overview &&
          aboutUsMsgData.aboutUs.overview
        );
        setMetaData(aboutUsMsgData &&
          aboutUsMsgData.aboutUs.meta &&
          aboutUsMsgData.aboutUs.meta);
      }

    }
  }, [aboutUsMsgData]);
  
  const [index, setIndex] = useState(0);

  const handleApiCall = async (e, tabName) => {
    setCurrentPageurl(tabName);
    // getAboutCorporateContent && getAboutCorporateContent({}, tabName);
    setFlag(true);
    setDefaultYear("");
  };

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const settings = {
    className: "center",
    dots: true,

    centerMode: true,
    infinite: true,
    centerPadding: "50px",
    slidesToShow: 1,
    speed: 500,
  };

  function handleSelectChange(event) {
    setDefaultYear(event.target.value);
  }

  useEffect(() => {
    if (defaultYear !== "") {
      let params = {
        year: defaultYear ? defaultYear : "",
      };
      postCsr && postCsr(formDataGenerator(params));
    }
  }, [defaultYear]);

  useEffect(() => {
    if (postCsrData && postCsrData.csr && postCsrData.csr.data) {
      setCsrList(postCsrData.csr.data);
    }
    if (postCsrData && postCsrData.csr && postCsrData.csr.meta) {
      setMetaData(postCsrData.csr.meta);
    }
    if (postCsrData && postCsrData.csr && postCsrData.csr.overview) {
      setOverView(postCsrData.csr.overview);
    }
  }, [postCsrData]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const openModal = (e, data) => {
    setIsOpenModel(true);
    setModalData(data);
  };

  const closeModal = () => {
    setIsOpenModel(false);
  };
  //dropdown start

  const dropdownRef = useRef(null);

  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [isOpen]);

  //dropdown end

  return (
    <div className={checkIframeContent() ? "wrapper":""}>
{current == "hdfc-mf-at-a-glance" || current == "what-we-stand-for" || current == "esg" || current == "csr" || current == "what-sets-us-apart" ? <> 
      {metaData && metaData !== null && <Helmet>
        <title>{metaData.title ? metaData.title : ""}</title>
        <meta name="description" content={metaData.description ? metaData.description : ""} />
        <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
        <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
        <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
        <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
        <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
      </Helmet>}

      <section className="aboutHead">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mx-auto">
              <div className="d-flex dropdowncls">
                <div class="dropdown me-auto" ref={dropdownRef}>
                  <div
                    id="dropdownMenuLink"
                    // data-bs-toggle="dropdown"
                    // aria-expanded="false"
                    onClick={toggleDropDown}
                  >
                    <h1>
                      <span>Corporate</span> Profile
                      <img
                        className="ms-2"
                        src="/images/New/redDownArrow.svg"
                        alt=""
                      />
                    </h1>
                  </div>
                  {isOpen && (
                    <ul
                      className="dropdown-body"
                      aria-labellewhat-we-care-aboutdby="dropdownMenuLink"
                    >
                      {overView &&
                        overView.length > 0 &&
                        overView.map((over, index) =>
                          over.linkName === "Corporate Profile" ? (
                            ""
                          ) : (
                            <li>
                              {checkIframeContent() ? <a
                                className="dropdown-item fw-bold"
                                href={over.routeConstant}
                              >
                                {over.linkName}
                              </a>:<Link
                                className="dropdown-item fw-bold"
                                to={getRouting(over.routeConstant)}
                              >
                                {over.linkName}
                              </Link>}
                            </li>
                          )
                        )}
                    </ul>
                  )}
                </div>
                <nav
                  aria-label="breadcrumb"
                  className="align-self-center breadCrumbCust d-md-inlin"
                >
                  <ol className="breadcrumb mb-0">
                    {checkIframeContent() && <li className="breadcrumb-item d-flex">
                      <a href="/">Home</a>
                    </li>}
                    <li className="breadcrumb-item d-flex">
                      <Link to={getRouting("/about-us", "About Us")}>
                        <div>
                          <p>About Us</p>
                        </div>
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item d-flex active breadcolor"
                      aria-current="page"
                    >
                      Corporate Profile
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="customSlick">
        <Tabs className="customTab" selectedIndex={selectedIndexTab}>
          <div className="container ctab">
            <div className="mrg_40">
              <TabList className="myClass slickOptions">
                <Link
                  to={getRouting(
                    "/about-us/corporate-profile/hdfc-mf-at-a-glance",
                    "HDFC MF at a Glance"
                  )}
                >
                  <Tab
                    onClick={async (e) =>
                      await handleApiCall(e, "hdfc-mf-at-a-glance")
                    }
                    tabFor="0"
                    value={0}
                  >
                    <div>
                      <p>HDFC MF at a Glance</p>
                    </div>
                  </Tab>
                </Link>
                <Link
                  to={getRouting(
                    "/about-us/corporate-profile/what-we-stand-for",
                    "What we stand for"
                  )}
                >
                  <Tab
                    onClick={async (e) =>
                      await handleApiCall(e, "what-we-stand-for")
                    }
                    tabFor="1"
                    value={1}
                  >
                    <div>
                      <p>What we stand for</p>
                    </div>
                  </Tab>
                </Link>
                {/* <Link to={getRouting('/about-us/corporate-profile/what-we-care-about', 'What we care about')}>
                  <Tab onClick={(e) => handleApiCall(e, 'what-we-care-about')}>
                    <div><p>What we care about</p></div>
                  </Tab>
                </Link> */}
                <Link to={getRouting("/about-us/corporate-profile/esg", "ESG")}>
                  <Tab
                    onClick={async (e) => await handleApiCall(e, "esg")}
                    tabFor="2"
                    value={2}
                  >
                    <div>
                      <p>ESG</p>
                    </div>
                  </Tab>
                </Link>
                <Link to={getRouting("/about-us/corporate-profile/csr", "CSR")}>
                  <Tab
                    onClick={async (e) => await handleApiCall(e, "csr")}
                    tabFor="3"
                    value={3}
                  >
                    <div>
                      <p>CSR</p>
                    </div>
                  </Tab>
                </Link>
                <Link
                  to={getRouting(
                    "/about-us/corporate-profile/what-sets-us-apart",
                    "What Sets Us Apart"
                  )}
                >
                  <Tab
                    onClick={async (e) =>
                      await handleApiCall(e, "what-sets-us-apart")
                    }
                    tabFor="4"
                    value={4}
                  >
                    <div>
                      <p>What Sets Us Apart</p>
                    </div>
                  </Tab>
                </Link>
              </TabList>
            </div>
          </div>
          <TabPanel>
            <div>
              <div className="container">
                <p className="head-title mt-4">
                  Discipline, good governance, and genuine care for our
                  stakeholders have helped HDFC Asset Management Company Limited
                  build a reputation for trust. Over the last two decades, HDFC
                  AMC has become one of the most prominent mutual fund houses in
                  India. We are committed to our mission of being a wealth
                  creator for every Indian. Here is a brief snapshot of some of
                  HDFC AMC's key milestones.
                </p>
              </div>
              <section className="hd-bg-pri hd-our-journey mt-3 mt-md-4">
                <div className="container containerSlick">
                  <div className="mrg_40">
                    <div className="row">
                      <h2 className="h2 mb-4 mb-md-0">Our Journey</h2>
                      <div className="d-block d-sm-none slickCustom p-0">
                        <div className="journeymobile d-flex justify-content-center">
                          <div>
                            <img src="/images/New/about-us/zigzag11.png" alt="zigzag-design-element" />
                            <div className="cricle-wrap">
                              <div className="mainwrap">
                                <div className="text-center textcls pr">
                                  <span>2000</span>
                                  <p>
                                    HDFC MF was
                                    <br /> registered with SEBI.
                                  </p>
                                </div>
                                <div className="div1">
                                  <div className=" img1">
                                  <img className="img-fluid" src="/images/New/about-us/2000.svg" alt="year-2000-icon" />
                                  </div>
                                </div>
                              </div>
                              <div className="mainwrap">
                                <div className="div2">
                                  <div className=" img2">
                                  <img className="img-fluid" src="/images/New/about-us/2001.svg" alt="year-2001-icon" />
                                  </div>
                                </div>
                                <div className="text-center textcls pl">
                                  <span>2001</span>
                                  <p>
                                    A joint venture was
                                    <br /> formed between
                                    <br /> HDFC Limited & <br />
                                    abrdn Investment <br />
                                    Management
                                    <br /> Limited (erstwhile <br />
                                    known as Standard Life
                                    <br /> Investments Limited)
                                  </p>
                                </div>
                              </div>
                              <div className="mainwrap">
                                <div className="text-center textcls pr">
                                  <span>2003</span>
                                  <p>
                                    Acquired Zurich Mutual
                                    <br /> Fund schemes
                                  </p>
                                </div>
                                <div className="div1">
                                  <div className=" img3">
                                  <img className="img-fluid" src="/images/New/about-us/2003.svg" alt="year-2003-icon" />
                                  </div>
                                </div>
                              </div>
                              <div className="mainwrap">
                                <div className="div2">
                                  <div className=" img4">
                                  <img className="img-fluid" src="/images/New/about-us/2014.svg" alt="year-2014-icon" />
                                  </div>
                                </div>
                                <div className="text-center textcls pleft">
                                  <span>2014</span>
                                  <p>
                                    Acquired Morgan <br />
                                    Stanley Mutual Fund
                                  </p>
                                </div>
                              </div>
                              <div className="mainwrap">
                                <div className="text-center textcls pr">
                                  <span>2018</span>
                                  <p>
                                    Launched IPO and
                                    <br />
                                    became a listed company
                                  </p>
                                </div>
                                <div className="div1">
                                  <div className=" img5">
                                  <img className="img-fluid" src="/images/New/about-us/2018.svg" alt="year-2018-icon" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {hdfcMfGlanceData &&
                        hdfcMfGlanceData.journey_data &&
                        hdfcMfGlanceData.journey_data.data &&
                        hdfcMfGlanceData.journey_data.data.length > 0 ? (
                        <div className="hd-timline-wrap hd-only-desktop">
                          <div className="hd-timeline-row pb-md-5 mb-md-4">
                            {hdfcMfGlanceData.journey_data.data[1] ? (
                              <div className="hd-timeline-parent">
                                <div className="hd-timeline-cnt">
                                  <span className="hd-timeline-year fnt-24">
                                    {hdfcMfGlanceData.journey_data.data[1]
                                      .name &&
                                      hdfcMfGlanceData.journey_data.data[1]
                                        .name}
                                  </span>
                                  {/* <p className="hd-timeline-des">A joint venture was formed between HDFC Limited &amp; abrdn Investment Management Limited (erstwhile known as Standard Life
                                  Investments Limited)</p> */}
                                  {hdfcMfGlanceData.journey_data.data[1]
                                    .description ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          hdfcMfGlanceData.journey_data.data[1]
                                            .description,
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            ) : null}
                            {hdfcMfGlanceData.journey_data.data[3] ? (
                              <div className="hd-timeline-parent">
                                <div className="hd-timeline-cnt">
                                  <span className="hd-timeline-year fnt-24">
                                    {hdfcMfGlanceData.journey_data.data[3]
                                      .name &&
                                      hdfcMfGlanceData.journey_data.data[3]
                                        .name}
                                  </span>
                                  {/* <p className="hd-timeline-des">Acquired Morgan Stanley Mutual Fund</p> */}
                                  {hdfcMfGlanceData.journey_data.data[3]
                                    .description ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          hdfcMfGlanceData.journey_data.data[3]
                                            .description,
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            ) : null}
                          </div>
                          <div className="hd-timline-illstr py-2">
                            <img
                              className="hd-imgfit w-100"
                              src="../../images/New/about-us/zigzag12.png"
                              alt="Illustartions"
                            />
                            <div className="hd-line-wrap">
                              <div className="hd-line-col">
                                <span />
                              </div>
                              <div className="hd-line-col">
                                <span />
                              </div>
                              <div className="hd-line-col">
                                <span />
                              </div>
                              <div className="hd-line-col">
                                <span />
                              </div>
                              <div className="hd-line-col">
                                <span />
                              </div>
                            </div>
                            <div className="hd-circle-wrap">
                              <div className="hd-circle-col">
                                <div className="hd-cirlce hd-flex-center">
                                  <img className="img-fluid" src="/images/New/about-us/2000.svg" alt="year-2000-icon" />
                                </div>
                              </div>

                              <div className="hd-circle-col">
                                <div className="hd-cirlce hd-flex-center">
                                  <img className="img-fluid" src="/images/New/about-us/2001.svg" alt="year-2001-icon" />
                                </div>
                              </div>

                              <div className="hd-circle-col">
                                <div className="hd-cirlce hd-flex-center">
                                  <img className="img-fluid" src="/images/New/about-us/2003.svg" alt="year-2003-icon" />
                                </div>
                              </div>

                              <div className="hd-circle-col">
                                <div className="hd-cirlce hd-flex-center">
                                  <img className="img-fluid" src="/images/New/about-us/2014.svg" alt="year-2014-icon" />
                                </div>
                              </div>

                              <div className="hd-circle-col">
                                <div className="hd-cirlce hd-flex-center">
                                  <img className="img-fluid" src="/images/New/about-us/2018.svg" alt="year-2018-icon" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="hd-timeline-row align-items-md-start pt-md-5 mt-md-4">
                            {hdfcMfGlanceData.journey_data.data[0] ? (
                              <div className="hd-timeline-col3">
                                <div className="hd-timeline-cnt">
                                  <span className="hd-timeline-year fnt-24">
                                    {hdfcMfGlanceData.journey_data.data[0]
                                      .name &&
                                      hdfcMfGlanceData.journey_data.data[0]
                                        .name}
                                  </span>
                                  {/* <p className="hd-timeline-des">HDFC MF was registered with SEBI.
                                </p> */}
                                  {hdfcMfGlanceData.journey_data.data[0]
                                    .description ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          hdfcMfGlanceData.journey_data.data[0]
                                            .description,
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            ) : null}
                            {hdfcMfGlanceData.journey_data.data[2] ? (
                              <div className="hd-timeline-col3">
                                <div className="hd-timeline-cnt">
                                  <span className="hd-timeline-year fnt-24">
                                    {hdfcMfGlanceData.journey_data.data[2]
                                      .name &&
                                      hdfcMfGlanceData.journey_data.data[2]
                                        .name}
                                  </span>
                                  {/* <p className="hd-timeline-des">Acquired Zurich Mutual Fund</p> */}
                                  {hdfcMfGlanceData.journey_data.data[2]
                                    .description ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          hdfcMfGlanceData.journey_data.data[2]
                                            .description,
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            ) : null}
                            {hdfcMfGlanceData.journey_data.data[4] ? (
                              <div className="hd-timeline-col3">
                                <div className="hd-timeline-cnt">
                                  <span className="hd-timeline-year fnt-24">
                                    {hdfcMfGlanceData.journey_data.data[4]
                                      .name &&
                                      hdfcMfGlanceData.journey_data.data[4]
                                        .name}
                                  </span>
                                  {/* <p className="hd-timeline-des">Launched its IPO and became a listed company</p> */}
                                  {hdfcMfGlanceData.journey_data.data[4]
                                    .description ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          hdfcMfGlanceData.journey_data.data[4]
                                            .description,
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </section>
              <section className="hd-facts-wrap">
                <div className="container containerSlick">
                  <div className="mrg_40">
                    {hdfcMfGlanceData &&
                      hdfcMfGlanceData.facts_and_figures_data ? (
                      <div className="row">
                        <div className="col-12">
                          <h3 className="hd-section-title mb-md-4 pb-3">
                            {hdfcMfGlanceData.facts_and_figures_data.title &&
                              hdfcMfGlanceData.facts_and_figures_data.title}
                          </h3>
                        </div>
                        {hdfcMfGlanceData &&
                          hdfcMfGlanceData.facts_and_figures_data.data &&
                          hdfcMfGlanceData &&
                          hdfcMfGlanceData.facts_and_figures_data.data.length >
                          0 &&
                          hdfcMfGlanceData.facts_and_figures_data.data.map(
                            (factFigure, index) => (
                              <div className="col-md-3" key={index}>
                                <figure className="hd-figure">
                                  <img
                                    src={
                                      factFigure.icon_url && factFigure.icon_url
                                    }
                                    alt={factFigure.icon_alt ? factFigure.icon_alt : ""}
                                  />
                                  <figcaption className="mt-2 mt-md-3 ps-3 ps-md-0">
                                    <h5 className="hd-fig-heading mb-2">
                                      {factFigure.name && factFigure.name}
                                    </h5>
                                    {/* <p className="hd-fig-des">in assets under management</p> */}
                                    {factFigure.description ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: factFigure.description,
                                        }}
                                      />
                                    ) : null}
                                  </figcaption>
                                </figure>
                              </div>
                            )
                          )}
                      </div>
                    ) : null}
                    {hdfcMfGlanceData && hdfcMfGlanceData.body ? (
                      <div className="row">
                        <div className="hd-cnt-wrap">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: hdfcMfGlanceData.body,
                            }}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </section>
            </div>
          </TabPanel>

          <TabPanel>
            <div>
              <div className="container containerSlick">
                <div className="mrg_40">
                  <div className="d-flex justify-content-center mt-73 d-flex-mobile">
                    {whatWestandForData &&
                      whatWestandForData.stand_for_data &&
                      whatWestandForData.stand_for_data.data &&
                      whatWestandForData.stand_for_data &&
                      whatWestandForData.stand_for_data.data.length > 0 &&
                      whatWestandForData.stand_for_data.data[1] ? (
                      <div className="grey-rectangle ">
                        <div className="cornor-anchor position-relative"></div>
                        <p className="vission">
                          {whatWestandForData.stand_for_data.data[1].name &&
                            whatWestandForData.stand_for_data.data[1].name}
                        </p>
                        {whatWestandForData.stand_for_data.data[1]
                          .description ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                whatWestandForData.stand_for_data.data[1]
                                  .description,
                            }}
                          />
                        ) : null}
                      </div>
                    ) : null}

                    {whatWestandForData &&
                      whatWestandForData.stand_for_data &&
                      whatWestandForData.stand_for_data.data &&
                      whatWestandForData.stand_for_data &&
                      whatWestandForData.stand_for_data.data.length > 0 &&
                      whatWestandForData.stand_for_data.data[0] ? (
                      <div className="grey-rectangle ms-100">
                        <div className="cornor-anchor1 position-relative"></div>
                        <p className="vission">
                          {whatWestandForData.stand_for_data.data[0].name &&
                            whatWestandForData.stand_for_data.data[0].name}
                        </p>
                        {whatWestandForData.stand_for_data.data[0]
                          .description ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                whatWestandForData.stand_for_data.data[0]
                                  .description,
                            }}
                          />
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          {/*
          <TabPanel>
            <div>
              <div className="container containerSlick">
                <div className="mrg_40 mt-5">
                  {whatWeCareData && whatWeCareData.body != "" ? <div
                    dangerouslySetInnerHTML={{ __html: whatWeCareData.body }}
                  /> : null}

                  <div className="custAccordian pb-5">
                    <Accordion defaultActiveKey="0" flush>
                      {whatWeCareData && whatWeCareData.care_about_data && whatWeCareData.care_about_data.data && whatWeCareData.care_about_data.data.length > 0 && whatWeCareData.care_about_data.data.map((careAbout, careAboutindex) => (
                        <Accordion.Item eventKey={careAboutindex.toString()}>
                          <Accordion.Header><p className="care-title">{careAbout.name && careAbout.name}</p></Accordion.Header>
                          <Accordion.Body>
                            <div className='d-none d-sm-block'>
                              {careAbout.image && careAbout.image && careAbout.image.file && careAbout.image.file.length > 0 && careAbout.image.file.map((img, imgIndex) => (
                                <div className="custom-center">
                                  <img className="img-fluid" src={img.url && img.url} />
                                </div>
                              ))}
                            </div>
                            <div className='d-block d-sm-none'>
                              {careAbout.image && careAbout.image && careAbout.image.file && careAbout.image.file.length > 0 ?
                                <Carousel className='carouselTab' onSelect={handleSelect}>
                                  {careAbout.image && careAbout.image && careAbout.image.file && careAbout.image.file.length > 0 && careAbout.image.file.map((img, imgIndex) => (
                                    <Carousel.Item>
                                      <img
                                        className="d-block mx-auto w-100 slide_img"
                                        src={img.url && img.url}
                                        alt=""
                                      />
                                    </Carousel.Item>
                                  ))}
                                </Carousel> : ""}
                            </div>
                            {careAbout.description ? <div
                              dangerouslySetInnerHTML={{ __html: careAbout.description }}
                            /> : null}
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel> */}

          <TabPanel>
            <div className="esg">
              <div className="mt-4 row justify-content-center">
                <div className="col-md-12">
                  <img
                    src={esgData && esgData.EsgBannerUrl}
                    className="img-fluid w-100"
                  />
                </div>
              </div>
              <div className="justify-content-center row">
                <div className="col-md-8">
                  <h2 className="esg-heading">{esgData && esgData.title}</h2>
                </div>
              </div>
              {/* <div className='col-md-12 ' >
                <img src={esgData && esgData.EsgBannerUrl} />
              </div> */}
              <div className="container">
                <div className="mission px-5 py-4">
                  {esgData &&
                    esgData.years &&
                    csrList.years.length > 0 &&
                    csrList.years.map((yer, index) => (
                      <option value={yer.value}>{yer.title}</option>
                    ))}

                  {esgData && esgData.body ? (
                    <div dangerouslySetInnerHTML={{ __html: esgData.body }} />
                  ) : null}
                </div>
                <div className="text-center my-4 esgmessage">
                  {esgData && esgData.afterOurMission ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: esgData.afterOurMission,
                      }}
                    />
                  ) : null}
                </div>
                <div className="priorities px-5 py-4 my-5">
                  {esgData && esgData.beforeSustainableFuture ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: esgData.beforeSustainableFuture,
                      }}
                    />
                  ) : null}

                  <div className="futurejourney d-flex justify-content-center">
                    <div>
                      {/* <img
                        src="/images/New/about-us/circle.svg"
                        className="img-fluid"
                      /> */}
                      <svg className="img-fluid" width="475" height="481" viewBox="0 0 475 481" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M237.325 20.5656C357.446 20.5656 454.823 119.199 454.823 240.87C454.823 362.541 357.446 461.175 237.325 461.175C117.204 461.175 19.8271 362.541 19.8271 240.87C31.8272 151.066 117.827 8.56556 245.827 20.7308" stroke="url(#paint0_linear_102_997)" strokeWidth="39.303" />
                         <defs>
                           <linearGradient id="paint0_linear_102_997" x1="127.132" y1="346.094" x2="407.632" y2="-36.906" gradientUnits="userSpaceOnUse">
                             <stop stopColor="#1B4B86" stopOpacity="0.08" />
                             <stop offset="1" stopColor="#1B4B86" stopOpacity="0.02" />
                           </linearGradient>
                         </defs>
                      </svg>
                      <div className="wrapcircle">
                        <div className="maincircle">
                          <img
                            src={
                              esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[1].icon_url
                            }
                          />
                          <p className="text-break">
                            {esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[1].name}
                          </p>
                        </div>
                        <div className="maincircle">
                          <img
                            src={
                              esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[2].icon_url
                            }
                          />
                          <p className="text-break">
                            {esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[2].name}
                          </p>
                        </div>
                        <div className="maincircle">
                          <img
                            src={
                              esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[3].icon_url
                            }
                          />
                          <p className="text-break">
                            {esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[3].name}
                          </p>
                        </div>
                        <div className="maincircle">
                          <img
                            src={
                              esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[4].icon_url
                            }
                          />
                          <p className="text-break">
                            {esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[4].name}
                          </p>
                        </div>
                        <div className="maincircle">
                          <img
                            src={
                              esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[5].icon_url
                            }
                          />
                          <p className="text-break">
                            {esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[5].name}
                          </p>
                        </div>
                        <div className="maincircle">
                          <img
                            src={
                              esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[6].icon_url
                            }
                          />
                          <p className="text-break">
                            {esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[6].name}
                          </p>
                        </div>
                        <div className="mainsquare">
                          <img
                            src={
                              esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[0].icon_url
                            }
                          />
                          <p className="text-break">
                            {esgData &&
                              esgData.sustainableFuture &&
                              esgData.sustainableFuture[0].name}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {esgData && esgData.afterSustainableFuture ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: esgData.afterSustainableFuture,
                      }}
                    />
                  ) : null}
                </div>
              </div>
              <div>
                <div className="esgtabsmain">
                  <Tabs>
                    <div className="container">
                      <TabList className="tablistdata">
                        <Tab>
                          <div>
                            <p>Environment</p>
                          </div>
                        </Tab>

                        <Tab>
                          <div>
                            <p>Social</p>
                          </div>
                        </Tab>

                        <Tab>
                          <div>
                            <p>Governance</p>
                          </div>
                        </Tab>
                      </TabList>
                    </div>
                    <TabPanel>
                      <div className="esgtabs">
                        <div className="container py-5">
                          {esgData &&
                            esgData.environmentTab &&
                            esgData.environmentTab.bannerdescription ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  esgData.environmentTab.bannerdescription,
                              }}
                            />
                          ) : null}
                        </div>
                      </div>
                      <div className="tabscontent">
                        <div className="container">
                          {esgData &&
                            esgData.environmentTab &&
                            esgData.environmentTab.description ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: esgData.environmentTab.description,
                              }}
                            />
                          ) : null}

                          <div className="row">
                            <div className="mb-3 mb-lg-0 col-lg-6 order-2">
                              <div className="d-flex flex-column">
                                {esgData &&
                                  esgData.environmentTab &&
                                  esgData.environmentTab.environmentInvest &&
                                  esgData.environmentTab.environmentInvest
                                    .length > 0 &&
                                  esgData.environmentTab.environmentInvest.map(
                                    (envi, envindex) => (
                                      <div className="initiativesdiv p-4 mb-4">
                                        <div className="toptrap"></div>
                                        <div className="toptrap1"></div>
                                        {envi && envi.body ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: envi.body,
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                        <div className="bottomtrap"></div>
                                        <div className="bottomtrap1"></div>
                                      </div>
                                    )
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 mb-md-0 col-lg-6 order-1">
                              <img
                                src={
                                  esgData &&
                                  esgData.environmentTab &&
                                  esgData.environmentTab.sideCardThumbnailUrl
                                }
                                className="envimg"
                              />
                            </div>
                          </div>
                          {esgData &&
                            esgData.environmentTab &&
                            esgData.environmentTab ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  esgData.environmentTab.environmentDisclaimer,
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {/* <p className="subtext mt-4">* Figures mentioned above are for FY’23 </p> */}
                          <div className="d-flex justify-content-end py-4">
                            <div
                              className="backtop d-flex align-items-center px-3 py-2"
                              onClick={() => scrollToTop()}
                            >
                              <img src="/images/New/about-us/toparrow.svg" alt="upward-arrow-icon" />
                              <p className="ms-3">Back to Top</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="esgtabs">
                        <div className="container py-5">
                          {esgData &&
                            esgData.socialTab &&
                            esgData.socialTab.bannerdescription ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: esgData.socialTab.bannerdescription,
                              }}
                            />
                          ) : null}
                        </div>
                      </div>
                      <div className="tabscontent">
                        <div className="container">
                          {esgData &&
                            esgData.socialTab &&
                            esgData.socialTab.description ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: esgData.socialTab.description,
                              }}
                            />
                          ) : null}
                          <div className="row">
                            <div className="mb-3 mb-lg-0 col-lg-6 order-2">
                              <div className="d-flex flex-column">
                                {esgData &&
                                  esgData.socialTab &&
                                  esgData.socialTab.socialInvest &&
                                  esgData.socialTab.socialInvest.length > 0 &&
                                  esgData.socialTab.socialInvest.map(
                                    (social, socialindex) => (
                                      <div className="initiativesdiv p-4 mb-4">
                                        <div className="toptrap"></div>
                                        <div className="toptrap1"></div>
                                        {social && social.body ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: social.body,
                                            }}
                                          />
                                        ) : null}
                                        <div className="bottomtrap"></div>
                                        <div className="bottomtrap1"></div>
                                      </div>
                                    )
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 mb-md-0 col-lg-6 order-1">
                              <img
                                src={
                                  esgData &&
                                  esgData.socialTab &&
                                  esgData.socialTab.sideCardThumbnailUrl
                                }
                                className="socialimg"
                              />
                            </div>
                          </div>
                          {esgData && esgData.socialTab ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: esgData.socialTab.financialDisclaimer,
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {/* <p className="subtext mt-4">Figures mentioned above are since launch of the initiative unless stated otherwise</p>
                          <p className="subtext">* CSR Beneficiaries for - FY’23</p> */}
                          <div className="d-flex justify-content-end py-4">
                            <div
                              className="backtop d-flex align-items-center px-3 py-2"
                              onClick={() => scrollToTop()}
                            >
                              <img src="/images/New/about-us/toparrow.svg" alt="upward-arrow-icon" />
                              <p className="ms-3">Back to Top</p>
                            </div>
                          </div>
                        </div>
                        <div className="esgdoc">
                          <div className="container py-4">
                            {esgData &&
                              esgData.socialTab &&
                              esgData.socialTab.afterInvestmentDiscription ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html:
                                    esgData.socialTab
                                      .afterInvestmentDiscription,
                                }}
                              />
                            ) : null}
                          </div>
                        </div>
                        <div>
                          <div className="container  py-5">
                            <h2 className="mb-4">Key Highlights</h2>
                            <div className="row justify-content-center">
                              {esgData &&
                                esgData.socialTab &&
                                esgData.socialTab.socialInvest &&
                                esgData.socialTab.keyHighlights.length > 0 &&
                                esgData.socialTab.keyHighlights.map(
                                  (keyHig, index) => (
                                    <div className="mb-4 col-md-6">
                                      <div className="keyhigh p-3 p-md-5">
                                        {keyHig && keyHig.body ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: keyHig.body,
                                            }}
                                          />
                                        ) : null}
                                      </div>
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                          <div className="bgwhite py-4">
                            <div className="container">
                              {esgData &&
                                esgData.socialTab &&
                                esgData.socialTab.upskillingBannerDesc ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      esgData.socialTab.upskillingBannerDesc,
                                  }}
                                />
                              ) : null}
                              {/* <div className="empkeydiv p-5">
                                {esgData &&
                                esgData.environmentTab &&
                                esgData.socialTab.keyHighlightDesc ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        esgData.socialTab.keyHighlightDesc,
                                    }}
                                  />
                                ) : null}
                              </div> */}
                              <div className="row my-4">
                                <div className="col-lg-6 mb-3 mb-lg-0">
                                  <img
                                    src={
                                      esgData &&
                                      esgData.socialTab &&
                                      esgData.socialTab.keyHighlightImageUrl
                                    }
                                    className="empimg"
                                  />
                                </div>
                                <div className="col-lg-6 mb-3 mb-lg-0 ">
                                  <div className="d-flex flex-column">
                                    {esgData &&
                                      esgData.socialTab &&
                                      esgData.socialTab.keyHighlightDesc &&
                                      esgData.socialTab.keyHighlightDesc
                                        .length > 0 &&
                                      esgData.socialTab.keyHighlightDesc.map(
                                        (upskill, upskillindex) => (
                                          <div className="upskillingdiv p-4 mb-4">
                                            <div className="toptrap"></div>
                                            <div className="toptrap1"></div>
                                            {upskill && upskill.body ? (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: upskill.body,
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}
                                            <div className="bottomtrap"></div>
                                            <div className="bottomtrap1"></div>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              </div>
                              {esgData && esgData.socialTab ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      esgData.socialTab.employeeDisclaimer,
                                  }}
                                />
                              ) : (
                                ""
                              )}
                              {/* <span className="subtext mt-4">Figures mentioned above are since launch of the initiative unless stated otherwise</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="esgtabs">
                        <div className="container py-5">
                          {esgData &&
                            esgData.governanceTab &&
                            esgData.governanceTab.bannerDescription ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: esgData.governanceTab.bannerDescription,
                              }}
                            />
                          ) : null}
                        </div>
                      </div>
                      <div className="tabscontent">
                        <div className="container">
                          {esgData &&
                            esgData.environmentTab &&
                            esgData.governanceTab.description ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: esgData.governanceTab.description,
                              }}
                            />
                          ) : null}
                          <div className="row">
                            <div className="col-lg-6 mb-3 mb-lg-0 order-2">
                              <div className="d-flex flex-column">
                                {esgData &&
                                  esgData.governanceTab &&
                                  esgData.governanceTab.governanceInvest &&
                                  esgData.governanceTab.governanceInvest
                                    .length > 0 &&
                                  esgData.governanceTab.governanceInvest.map(
                                    (gover, goverindex) => (
                                      <div className="initiativesdiv p-4 mb-4">
                                        <div className="toptrap"></div>
                                        <div className="toptrap1"></div>
                                        {gover && gover.body ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: gover.body,
                                            }}
                                          />
                                        ) : null}
                                        <div className="bottomtrap"></div>
                                        <div className="bottomtrap1"></div>
                                      </div>
                                    )
                                  )}
                              </div>
                            </div>
                            <div className="col-lg-6 mb-3 mb-lg-0 order-1">
                              <img
                                src={
                                  esgData &&
                                  esgData.governanceTab &&
                                  esgData.governanceTab.sideCardThumbnailUrl
                                }
                                className="govimg"
                              />
                            </div>
                          </div>
                          {esgData && esgData.governanceTab ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  esgData.governanceTab.governanceDisclaimer,
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {/* <p className="subtext mt-4">Figures mentioned above are for FY’23 </p> */}
                          <div className="d-flex justify-content-end py-4">
                            <div
                              className="backtop d-flex align-items-center px-3 py-2"
                              onClick={() => scrollToTop()}
                            >
                              <img src="/images/New/about-us/toparrow.svg" alt="upward-arrow-icon" />
                              <p className="ms-3">Back to Top</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                  <div className="container commonsec my-4">
                    <div className="esgdoc">
                      <div className="py-4">
                        <h2 className="mb-4">Click to view ESG Documents</h2>
                        <div className="row">
                          {/* <Col md={5}>
                            {esgData && esgData.documentDescription ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: esgData.documentDescription,
                                }}
                              />
                            ) : null}
                           
                          </Col> */}
                          <div className="col-md-6 mt-3 mt-md-0">
                            <div className="row">
                              {esgData &&
                                esgData.files &&
                                esgData.files.length > 0 &&
                                esgData.files.map((fil, index) => (
                                  <div className="col-md-6">
                                    <a
                                      href={fil.url}
                                      className="d-flex align-items-center mb-4"
                                      target="_blank"
                                    >
                                      <div className="me-3">
                                        <img
                                          src="/images/New/about-us/download.svg"
                                          className="h-100"
                                        />
                                      </div>
                                      <p>{fil.filename}</p>
                                    </a>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr className="separator" />
                    <div className="row justify-content-center esglogo">
                    {esgData && esgData.priLogo && esgData.priLogo.url ? (
                      <div className="pricol">
                        <div className="mb-4 text-center">
                          <img
                            src={
                              esgData && esgData.priLogo && esgData.priLogo.url
                            }
                            alt={
                              esgData && esgData.priLogo && esgData.priLogo.alt
                            }
                            className="img-fluid priload12"
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                      <div className="pricol">
                        <div className='d-flex justify-content-center'>
                          <img src="/images/New/ClimateAction100_withNEWTagline.webp" alt="ClimateAction100" className='climate-img' />
                          <img src="/images/New/ClimateAction100_withNEWTagline_WHITE.webp" alt="ClimateAction100" className='climatedark-img' />
                        </div>
                      </div>
                      <div className="pricol">
                        <div className='d-flex justify-content-center'>
                          <img src="/images/New/CFALogoDark.webp" alt="CFA Logo" className='cfalogo-dark mb-4' />
                          <img src="/images/New/CFALogoLight.webp" alt="CFA Logo" className='cfalogo mb-4' />
                        </div>
                      </div>
                    </div>

                    {/* <div className="py-5">
                      <h2 className="mb-3">Awards and Accolades</h2>
                      <Row className="gx-5">
                        {esgData &&
                          esgData.awardsAccolades &&
                          esgData.awardsAccolades.length > 0 &&
                          esgData.awardsAccolades.map((award, index) => (
                            <Col md={6} className="">
                              <div className="p-3 d-md-flex awardcard mb-3">
                                <img
                                  src={award.thumbnailUrl}
                                  className="img-fluid"
                                />
                                <div className="ms-3">
                                  <h2> {award.title}</h2>
                                  <p>
                                    {" "}
                                    {award && award.description ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: award.description,
                                        }}
                                      />
                                    ) : null}
                                  </p>
                                </div>
                              </div>
                            </Col>
                          ))}
                      </Row>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            <div className="csrtab">
              <div>
                <div className="row headsec">
                  <div className="col-6 d-flex align-items-center justify-content-center">
                    <div className="container">
                      <h2 className="csrhead">{csrList && csrList.title}</h2>
                    </div>
                  </div>
                  <div className="col-6">
                    <img
                      src={csrList && csrList.bannerUrl}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="container">
                  <div className="csrmainsec mb-5 p-5">
                    {csrList && csrList.body ? (
                      <div dangerouslySetInnerHTML={{ __html: csrList.body }} />
                    ) : null}
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <h3 className="csr-h3 mb-3">Select Financial Year</h3>
                      <div className="input-group inputt">
                        <select
                          className="form-select year-drop py-3"
                          id="inputGroupSelect04"
                          aria-label="Example select with button addon"
                          onChange={handleSelectChange}
                        >
                          {csrList &&
                            csrList.years &&
                            csrList.years.length > 0 &&
                            csrList.years.map((yer, index) => (
                              <option value={yer.value}>{yer.title}</option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="csrcard">
                    <div className="row">
                      {csrList &&
                        csrList.care_about_data &&
                        csrList.care_about_data.length > 0 &&
                        csrList.care_about_data.map((csrDataUS, index) => (
                          <div className="col-md-4 mb-4">
                            <div class="card">
                              <img class="card-img-top csr-blog"
                                src={
                                  csrDataUS &&
                                  csrDataUS.thumbnail &&
                                  csrDataUS.thumbnail.url
                                }
                                onClick={(e) => openModal(e, csrDataUS)} />
                              <div class="card-body px-0">
                                <div className="csr-blog card-title"
                                  onClick={(e) => openModal(e, csrDataUS)}> {csrDataUS.name}</div>
                              </div>
                            </div>
                            {/* <Card>
                              <Card.Img
                                className="csr-blog"
                                variant="top"
                                src={
                                  csrDataUS &&
                                  csrDataUS.thumbnail &&
                                  csrDataUS.thumbnail.url
                                }
                                onClick={(e) => handleShow(e, csrDataUS)}
                              />
                              <Card.Body className="px-0">
                                <Card.Title
                                  className="csr-blog"
                                  onClick={(e) => handleShow(e, csrDataUS)}
                                >
                                  {csrDataUS.name}
                                </Card.Title>
                              </Card.Body>
                            </Card> */}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            {whatSetsUsApart && whatSetsUsApart.body ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: whatSetsUsApart && whatSetsUsApart.body,
                }}
                className="sets-apart"
              />
            ) : null}
          </TabPanel>
        </Tabs>
      </section>
      <CsrModal open={isOpenModel} onClose={closeModal} content={modalData} /></>:<PageNotFound/>}
    </div>
  );
};
const mapStateToProps = (state) => ({
  aboutUsMsgData: state.aboutnew.home.aboutUsMsg,
  postCsrData: state.aboutnew.home.csrData,
});

const mapDispatchToProps = (dispatch) => ({
  getAboutCorporateContent: bindActionCreators(
    getAboutCorporateContent,
    dispatch
  ),
  postCsr: bindActionCreators(postCsr, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CorporateProfile);
